import { RESI_ROUTER_NAMESPACE } from 'utils/route-guard/ResiGuard';

export const resiRouteMatchers = {
    uploadIdentification: pathname =>
        pathname === `${RESI_ROUTER_NAMESPACE}/upload-identification`,
    guestsHome: pathname => pathname === `${RESI_ROUTER_NAMESPACE}/guests`,
    accessKeys: pathname => pathname === `${RESI_ROUTER_NAMESPACE}/access-keys`,
    occupantsHome: pathname => pathname === `${RESI_ROUTER_NAMESPACE}/occupants`,
    rentalsHome: pathname => pathname === `${RESI_ROUTER_NAMESPACE}/rentals`,
    vehicles: pathname => pathname === `${RESI_ROUTER_NAMESPACE}/vehicles`
};
